import { c as _c } from "react/compiler-runtime";
import { Transition } from "@headlessui/react";
import clsx from "clsx";
import { FC, ReactElement, useCallback, useEffect, useRef, useState } from "react";
const duration = 8000;
export interface SlideshowProps {
  children: ReactElement[];
}
const Progress = t0 => {
  const $ = _c(17);
  const {
    isActive,
    isDone,
    isAnimating,
    onClick
  } = t0;
  let t1;
  if ($[0] !== isActive) {
    t1 = isActive ? {
      animationPlayState: "running",
      animationTimingFunction: "linear",
      animationDuration: `${duration}ms`
    } : undefined;
    $[0] = isActive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const style = t1;
  const t2 = !isActive;
  let t3;
  if ($[2] !== isActive || $[3] !== t2) {
    t3 = clsx("rounded-xs h-2xs group-hover:bg-neutral-425 group-hover:bg-opacity-50", {
      "bg-neutral-50": t2,
      "bg-neutral-425 bg-opacity-50": isActive
    });
    $[2] = isActive;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isAnimating && isActive;
  const t5 = !isActive || !isAnimating && !isDone;
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = clsx("bg-neutral-100 h-2xs rounded-xs", {
      "animate-progress": t4,
      hidden: t5
    });
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== style || $[9] !== t6) {
    t7 = <div style={style} className={t6} />;
    $[8] = style;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t7) {
    t8 = <div className={t3}>{t7}</div>;
    $[11] = t3;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== onClick || $[15] !== t8) {
    t9 = <button className="cursor-pointer p-2xs -m-2xs w-full group" onClick={onClick}>{t8}</button>;
    $[14] = onClick;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
const Slideshow: FC<SlideshowProps> = t0 => {
  const $ = _c(29);
  const {
    children
  } = t0;
  const numberOfSlides = children.length;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(true);
  const timeoutRef = useRef(undefined);
  let t1;
  if ($[0] !== numberOfSlides) {
    t1 = () => {
      setCurrentIndex(i => (i + 1) % numberOfSlides);
    };
    $[0] = numberOfSlides;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const next = t1;
  let t2;
  let t3;
  if ($[2] !== isAnimating || $[3] !== next) {
    t2 = () => {
      if (timeoutRef.current) {
        clearInterval(timeoutRef.current);
      }
      const nextSlide = () => {
        if (!isAnimating) {
          return;
        }
        next();
      };
      timeoutRef.current = window.setInterval(nextSlide, duration);
      return () => {
        if (timeoutRef.current) {
          clearInterval(timeoutRef.current);
        }
      };
    };
    t3 = [next, isAnimating];
    $[2] = isAnimating;
    $[3] = next;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsAnimating(false);
    t5 = () => setIsAnimating(true);
    t6 = () => setIsAnimating(false);
    t7 = () => setIsAnimating(true);
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== children || $[11] !== currentIndex) {
    let t9;
    if ($[13] !== currentIndex) {
      t9 = (child, index) => <Transition show={index === currentIndex} key={index}><div className="absolute inset-none transition-opacity duration-500 opacity-100 data-[enter]:opacity-0 data-[leave]:opacity-0">{child}</div></Transition>;
      $[13] = currentIndex;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    t8 = children.map(t9);
    $[10] = children;
    $[11] = currentIndex;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <div className="grow w-full h-full relative">{t8}</div>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== children || $[18] !== currentIndex || $[19] !== isAnimating) {
    let t11;
    if ($[21] !== currentIndex || $[22] !== isAnimating) {
      t11 = (_, index_0) => <Progress key={index_0} isDone={index_0 < currentIndex} isAnimating={isAnimating} isActive={currentIndex === index_0} onClick={() => setCurrentIndex(index_0)} />;
      $[21] = currentIndex;
      $[22] = isAnimating;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    t10 = children.map(t11);
    $[17] = children;
    $[18] = currentIndex;
    $[19] = isAnimating;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[24] !== t10) {
    t11 = <div className="flex flex-none gap-3xs absolute inset-x-m bottom-m">{t10}</div>;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t9) {
    t12 = <div className="flex w-full relative" onFocus={t4} onBlur={t5} onMouseOver={t6} onMouseOut={t7}>{t9}{t11}</div>;
    $[26] = t11;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
export default Slideshow;